"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Image.css");
var _Default_photo = _interopRequireDefault(require("../assets/Default_photo.png"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : Photo.js
* Description : Ce fichier contient la définition du composant Photo 
*               Ce composant affiche la photo d'un utilisateur en s'adaptant à la taille de l'écran
* Date de création : 8 octobre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */
// None

/* Hook */

/**
* Photo : ce composant affiche une photo en s'adaptant à la taille de l'écran
*         si aucune URL n'est fournie, c'est une photo par défaut qui est affichée
*
* Type : composant 
*
* Parametres : 
*  - url -- URL de la photo
*/function Photo(_ref) {
  var url = _ref.url;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex-row justify-center",
    children: url !== null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: url,
      alt: "photo_item",
      className: "photo"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _Default_photo["default"],
      alt: "Default_image",
      className: "photo"
    })
  });
}
var _default = exports["default"] = Photo;